const OperatorId = 1;
const lteHttpBaseUrl = window['url'];// || 'http://localhost:8088';
//const webHookUrl= "http://212.100.86.49:8080/Billing/webhook";
const webHookUrl= "https://ltemobilemid.cyberspace.net.ng/api/PaymentFactory/LTESelfCareWebhook";
export const environment = {
  production: false,
  lteHttpBaseUrl:window['url'],
  OperatorID: OperatorId,
  PortalCode:"PortalCode" + OperatorId,
 // IntegrationKey : window['integrationKey'] || "c041e4ba3ade40898e1eb9e8a16c4d16",
  // IntegrationKey : window['integrationKey'] || "e38f9fbc3b8d4b4d866f1735b6d670e2", 
  // voiceIntegrationKey : window['voiceIntegrationKey'] || "86d2f18326ea4783bbf5bee893fd0fcf",
  // enterpriseIntegrationKey:window['enterpriseIntegrationKey']||"1552fba96cc94cab93523d18bdb8c496",
  // cyberPayApiUrl:"https://payment-api.cyberpay.ng/api/v1/payments",
  // ProviderId : 4,
//   IntegrationKey :"c041e4ba3ade40898e1eb9e8a16c4d16",//"005e84081f9f408586de873338fa54b7"
//   voiceIntegrationKey :"c041e4ba3ade40898e1eb9e8a16c4d16",
//   enterpriseIntegrationKey:"0edbb40477fb4b1b95e45bb2af44d6bd",
//   cyberPayApiUrl: "https://payment-api.staging.cyberpay.ng/api/v1/payments/",
 

IntegrationKey : window['integrationKey'] || "e38f9fbc3b8d4b4d866f1735b6d670e2", 
  voiceIntegrationKey : window['voiceIntegrationKey'] || "86d2f18326ea4783bbf5bee893fd0fcf",
  enterpriseIntegrationKey:window['enterpriseIntegrationKey']||"1552fba96cc94cab93523d18bdb8c496",
  cyberPayApiUrl: "https://payment-api.cyberpay.ng/api/v1/payments",
  ProviderId : 4,
  GenericErrorMsg : "An error occured",
  CyberPayReturnURL: `${location.protocol}//${location.host}/completecyberpay`,
  expiredAccId : 3,
  pausedAccId:0,
  UnsubscribeUrl:"https://externalconn.cyberspacelte.net.ng:9088/api/utilities/Unsubscribe",
 webhookUrl : webHookUrl,
 vat: 7.5
};
